import { GlobalStyle } from "./styles/Global";
import Home from "./components/Home/Home";

function App() {
  return (
    <div>
      <GlobalStyle />
      <Home />
    </div>
  );
}

export default App;
